let usage = `
<Tooltip placement="right">
  <div slot="popover">
    C'est vraiment pratique, l’utilisation du mini TPE est très complète
    (en plus d’être beaucoup moins cher qu'un TPE classique en location).
  </div>
  <Button slot="reference" padding="10px">Custom Tooltip</Button>
</Tooltip>
`.slice(1);

export default {
  usage
};
